import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { useInstallPrompt } from "@/lib/install";
import { Download, Smartphone, Share2, Plus } from "lucide-react";

export const InstallAppButton = ({ variant = "compact" }) => {
    const { canInstall, installed, isIOS, triggerInstall } = useInstallPrompt();
    const [iosOpen, setIosOpen] = useState(false);

    if (installed) return null;
    if (!canInstall && !isIOS) return null;

    const onClick = async () => {
        if (isIOS && !canInstall) {
            setIosOpen(true);
            return;
        }
        await triggerInstall();
    };

    if (variant === "hero") {
        return (
            <>
                <Button onClick={onClick} className="bg-[#22d3ee] hover:brightness-110 text-[#062229] h-12 px-6 font-semibold inline-flex items-center gap-2" data-testid="install-app-button">
                    <Smartphone className="w-4 h-4" /> Install HOTSLIP App
                </Button>
                <IOSInstructionsDialog open={iosOpen} setOpen={setIosOpen} />
            </>
        );
    }

    return (
        <>
            <Button
                onClick={onClick}
                variant="secondary"
                size="sm"
                className="bg-[#06181f] border border-[#22d3ee]/40 text-[#22d3ee] hover:brightness-110 inline-flex items-center gap-1.5"
                data-testid="install-app-button"
            >
                <Download className="w-3.5 h-3.5" /> Install App
            </Button>
            <IOSInstructionsDialog open={iosOpen} setOpen={setIosOpen} />
        </>
    );
};

function IOSInstructionsDialog({ open, setOpen }) {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="pp-bg-1 border-[#242436] text-white">
                <DialogHeader>
                    <DialogTitle className="font-display tracking-widest text-2xl inline-flex items-center gap-2">
                        <Smartphone className="w-6 h-6 text-[#22d3ee]" /> INSTALL ON iPHONE
                    </DialogTitle>
                </DialogHeader>
                <ol className="space-y-3 text-sm text-[#e6e6f0]">
                    <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#22d3ee] text-[#062229] font-bold flex items-center justify-center">1</span>
                        <span>Tap the <Share2 className="inline w-3.5 h-3.5" /> Share button at the bottom of Safari.</span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#22d3ee] text-[#062229] font-bold flex items-center justify-center">2</span>
                        <span>Scroll and tap <strong className="text-white"><Plus className="inline w-3.5 h-3.5" /> Add to Home Screen</strong>.</span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#22d3ee] text-[#062229] font-bold flex items-center justify-center">3</span>
                        <span>Tap <strong className="text-white">Add</strong> in the top-right corner. HOTSLIP will appear as an app icon!</span>
                    </li>
                </ol>
                <p className="text-xs text-[#8b8ba0] mt-2">Note: install only works in <strong>Safari</strong> on iOS, not Chrome.</p>
                <DialogFooter>
                    <Button onClick={() => setOpen(false)} className="bg-[#6f3fec] hover:brightness-110 text-white">Got it</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
